import { render, staticRenderFns } from "./CodeOfConduct.vue?vue&type=template&id=2748e872&"
import script from "./CodeOfConduct.vue?vue&type=script&lang=js&"
export * from "./CodeOfConduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports